import { Link, ResponsiveImage, LazyLoadImages } from "@quintype/components";
import { StoryCardSkeleton } from "../skeleton/DesktopSkelton";
import React from "react";
import { timeAgo } from "../../utils/published-date";
import { ResponsiveBannerImage } from "../../utils/responsive-image";

export default function StoryWithImage({ story, author = true }) {
  if (!story) {
    return (
      <div className="mb-2 pb-3">
        <StoryCardSkeleton />
      </div>
    );
  }
  return (
    <>
      <div className="mb-2 pb-3">
        <Link href={`/${story.story.slug}`}>
          <div>
            <LazyLoadImages>
              {/* <ResponsiveImage
                slug={story.story["hero-image-s3-key"]}
                aspect-ratio={[1, 1]}
                defaultWidth={400}
                imgParams={{ auto: ["format", "compress"], q: 75, fm: "webp" }}
                alt="image"
              /> */}
              <ResponsiveBannerImage
                slug={story.story["hero-image-s3-key"]}
                alt={story.story.headline}
                width="330"
                quality="75"
              />
            </LazyLoadImages>
            <div>
              <h4 className="mt-3 text-base font-[470] hover:text-[#737275]">{story.story.headline}</h4>

              <div className="mt-2 flex flex-row items-center justify-start gap-3 text-xs">
                {author && (
                  <>
                    <div className="relative leading-[18px] text-[#ca4242]">
                      <span> {story.story.authors[0].name}</span>
                    </div>
                    <div className="text-dimgray relative font-medium leading-[18px] text-[#737275]">
                      <span>{timeAgo(story.story["content-updated-at"])}</span>{" "}
                      {/* <span className=" text-primary"> | </span> */}
                      {/* <span>
                    {story.sections[0]["name"] ||
                      story.sections[0]["display_name"]}
                  </span> */}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </Link>
      </div>
    </>
  );
}
